/* Local Citations X — small progressive enhancements. The site works without this file. */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.add('js');

  /* Header: hairline border once scrolled */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile navigation */
  var nav = document.getElementById('MobileNav');
  var openBtn = document.querySelector('[data-nav-open]');
  if (nav && openBtn) {
    var closeBtn = nav.querySelector('[data-nav-close]');
    var lastFocus = null;
    var focusables = function () { return nav.querySelectorAll('a[href], button:not([disabled])'); };
    var setOpen = function (open) {
      nav.classList.toggle('is-open', open);
      nav.setAttribute('aria-hidden', String(!open));
      openBtn.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('nav-open', open);
      if (open) {
        lastFocus = document.activeElement;
        nav.removeAttribute('inert');
        (closeBtn || focusables()[0]).focus();
      } else {
        nav.setAttribute('inert', '');
        if (lastFocus) lastFocus.focus();
      }
    };
    openBtn.addEventListener('click', function () { setOpen(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') return setOpen(false);
      if (e.key !== 'Tab') return;
      var items = focusables(); var first = items[0]; var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) { if (mq.matches) setOpen(false); });
  }

  /* Reveal on scroll (restrained) */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Quantity steppers (cart) */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
  document.querySelectorAll('[data-autosubmit]').forEach(function (form) {
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        // Drop intake requirements for a plain quantity update
        form.querySelectorAll('[required]').forEach(function (el) { el.removeAttribute('required'); el.setAttribute('data-was-required', ''); });
        var u = document.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; form.appendChild(u);
        form.submit();
      }, 500);
    });
  });

  /* Cart intake: switch between "provide now" and "send after purchase" */
  var intakeToggle = document.querySelector('[data-intake-later]');
  if (intakeToggle) {
    var fields = document.querySelector('[data-intake-fields]');
    var sync = function () {
      var later = intakeToggle.checked;
      fields.hidden = later;
      fields.querySelectorAll('[data-required]').forEach(function (el) {
        if (later) el.removeAttribute('required'); else el.setAttribute('required', '');
        el.disabled = later;
      });
    };
    intakeToggle.addEventListener('change', sync);
    sync();
  }

  /* Accessible client-side validation for forms marked data-validate */
  document.querySelectorAll('form[data-validate]').forEach(function (form) {
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.name === 'update') return;
      if (!form.checkValidity()) {
        e.preventDefault();
        form.classList.add('was-validated');
        var firstInvalid = null;
        form.querySelectorAll('input, select, textarea').forEach(function (el) {
          var bad = !el.disabled && !el.checkValidity();
          el.setAttribute('aria-invalid', String(bad));
          if (bad && !firstInvalid) firstInvalid = el;
        });
        var summary = form.querySelector('[data-error-summary]');
        if (summary) { summary.hidden = false; }
        if (firstInvalid) firstInvalid.focus();
      }
    });
    form.addEventListener('input', function (e) {
      if (form.classList.contains('was-validated') && e.target.checkValidity()) e.target.setAttribute('aria-invalid', 'false');
    });
  });

  /* Publish a custom analytics event after a successful quote / intake submission.
     Subscribed to in Shopify Customer events (see docs/ANALYTICS.md). */
  document.querySelectorAll('[data-analytics-success]').forEach(function (el) {
    var name = el.getAttribute('data-analytics-success');
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, { form: name, page: location.pathname });
      }
    } catch (err) { /* analytics must never block the page */ }
  });
})();
